import { render, staticRenderFns } from "./InDepthAnswer.vue?vue&type=template&id=0d87d9e9&"
import script from "./InDepthAnswer.vue?vue&type=script&lang=js&"
export * from "./InDepthAnswer.vue?vue&type=script&lang=js&"
import style0 from "./InDepthAnswer.vue?vue&type=style&index=0&id=0d87d9e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports